// frontend/src/layouts/MainLayout.jsx
import React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuth, logout } from '../auth/auth';
import NavBar from '../components/NavBar';

const MainLayout = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setUser(null);
    navigate('/');
  };

  return (
    <div className="main-layout flex flex-col min-h-screen">
      <NavBar user={user} onLogout={handleLogout} isAdmin={false} />
      <main className="main-content flex-1">
        <Outlet />
      </main>
      <footer className="footer text-center py-4 text-gray-600 bg-white shadow-inner">
        <p>© {new Date().getFullYear()} Annuity Lead System. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default MainLayout;